<template>
    <BaseBtn :id="id" v-on="$listeners" :href="goToOkrTree(objectiveId)">
        <img :src="OKRsChartIcon" height="18" alt="OKRs chart icon" />
    </BaseBtn>
</template>

<script>
import BaseBtn from './BaseBtn'
import OKRsChartIcon from '@/assets/icons/okr.svg'
import { getV1PathWithOrigin } from '@/router/routesToV1'

export default {
    name: 'OKRsChartBtn',
    components: {
        BaseBtn,
    },
    data() {
        return {
            OKRsChartIcon,
        }
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        objectiveId: {
            type: [Number, String],
            required: true,
        },
    },
    methods: {
        goToOkrTree(objectiveId) {
            return `${getV1PathWithOrigin('/okr/objectives/tree', { objectiveId })}`
        },
    },
}
</script>
